import * as React from 'react';

export interface OutputDetailProps {
  incomeFrequency: string;
  currentIncome: string;
  plannedIncome: string;
  lumpsum: string;
  timeFrame: string;
}

const OutputDetail = ({
  incomeFrequency,
  currentIncome,
  plannedIncome,
  lumpsum,
  timeFrame,
}: OutputDetailProps) => (
  <div className="output-detail">
    <div className="container">
      <div className="output-detail__header">
        <h2 className="output-detail__title show-print">Income Planner</h2>
      </div>
      <p className="output-detail__body">
        By changing your <span className="highlight">{incomeFrequency}</span> from <span className="highlight">{currentIncome}</span> to <span className="highlight">{plannedIncome}</span> and taking <span className="highlight">{lumpsum}</span> as a single lump sum, your pension pot could run out <span className="highlight">{timeFrame}</span> than your current income plan.
      </p>
    </div>
  </div>
);

export default OutputDetail;



// WEBPACK FOOTER //
// ./src/components/Outputs/OutputDetail/OutputDetail.tsx